import { render, staticRenderFns } from "./tipspayrollnews.vue?vue&type=template&id=78ed2bc2&scoped=true"
import script from "./tipspayrollnews.vue?vue&type=script&lang=js"
export * from "./tipspayrollnews.vue?vue&type=script&lang=js"
import style0 from "./tipspayrollnews.vue?vue&type=style&index=0&id=78ed2bc2&prod&lang=scss&scoped=true"
import style1 from "./tipspayrollnews.vue?vue&type=style&index=1&id=78ed2bc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ed2bc2",
  null
  
)

export default component.exports